<template>
  <div class="cont">
    <div class="headc  heada">
      <div :style="{width: rateList[0]}" style="border-top-left-radius: 10px;">年份</div>
      <div :style="{width: rateList[1]}">计划</div>
      <div :style="{width: rateList[2]}">最低分</div>
      <div :style="{width: rateList[3]}" v-if="showflag">等效分</div>
      <div :style="{width: rateList[4]}">等位分</div>
      <div :style="{width: rateList[5]}">最低位次</div>
      <div :style="{width: rateList[6]}" style="border-top-right-radius: 10px;">分差/位差</div>
    </div>
    <div class="headc" v-if="one!=null">
      <div :style="{width: rateList[0]}">{{year}}</div>
      <div :style="{width: rateList[1]}">{{getNull(one.scorePlanNum)}}</div>
      <div :style="{width: rateList[2]}">{{getNull(one.scoreMin)}}</div>
      <div :style="{width: rateList[3]}" v-if="showflag">{{getNull(one.spare1)}}</div>
      <div :style="{width: rateList[4]}">{{getNull(one.spare2)}}</div>
      <div :style="{width: rateList[5]}">{{getNull(one.scoreMinRank)}}</div>
      <div :style="{width: rateList[6]}">
      <span  :style="{color:$utils.getScorecolor(scorea.score,one.spare2,1)}">{{ $utils.getScoreCha(scorea.score,one.spare2,1) }}</span>
      /<span  :style="{color:$utils.getScorecolor(scorea.scoreRank,one.scoreMinRank,0)}">{{ $utils.getScoreCha(scorea.scoreRank,one.scoreMinRank,0) }}</span>

      </div>
    </div>
    <div class="headc" v-else>
      <div :style="{width: rateList[0]}">{{year}}</div>
      <div :style="{width: rateList[1]}">--</div>
      <div :style="{width: rateList[2]}">--</div>
      <div :style="{width: rateList[3]}" v-if="showflag">--</div>
      <div :style="{width: rateList[4]}">--</div>
      <div :style="{width: rateList[5]}">--</div>
      <div :style="{width: rateList[6]}">--</div>
    </div>
    <div class="headc" v-if="two!=null">
      <div :style="{width: rateList[0]}">{{year-1}}</div>
      <div :style="{width: rateList[1]}">{{getNull(two.scorePlanNum)}}</div>
      <div :style="{width: rateList[2]}">{{getNull(two.scoreMin)}}</div>
      <div :style="{width: rateList[3]}" v-if="showflag">{{getNull(two.spare1)}}</div>
      <div :style="{width: rateList[4]}">{{getNull(two.spare2)}}</div>
      <div :style="{width: rateList[5]}">{{getNull(two.scoreMinRank)}}</div>
      <div :style="{width: rateList[6]}">
        <span  :style="{color:$utils.getScorecolor(scorea.score,two.spare2,1)}">{{ $utils.getScoreCha(scorea.score,two.spare2,1) }}</span>
        /<span  :style="{color:$utils.getScorecolor(scorea.scoreRank,two.scoreMinRank,0)}">{{ $utils.getScoreCha(scorea.scoreRank,two.scoreMinRank,0) }}</span>
      </div>
    </div>
    <div class="headc" v-else>
      <div :style="{width: rateList[0]}">{{year-1}}</div>
      <div :style="{width: rateList[1]}">--</div>
      <div :style="{width: rateList[2]}">--</div>
      <div :style="{width: rateList[3]}" v-if="showflag">--</div>
      <div :style="{width: rateList[4]}">--</div>
      <div :style="{width: rateList[5]}">--</div>
      <div :style="{width: rateList[6]}">--</div>
    </div>
    <div class="headc" v-if="three!=null">
      <div :style="{width: rateList[0]}" style="border-bottom-left-radius: 10px;">{{year-2}}</div>
      <div :style="{width: rateList[1]}">{{getNull(three.scorePlanNum)}}</div>
      <div :style="{width: rateList[2]}">{{getNull(three.scoreMin)}}</div>
      <div :style="{width: rateList[3]}" v-if="showflag">{{getNull(three.spare1)}}</div>
      <div :style="{width: rateList[4]}">{{getNull(three.spare2)}}</div>
      <div :style="{width: rateList[5]}">{{getNull(three.scoreMinRank)}}</div>
      <div :style="{width: rateList[6]}" style="border-bottom-right-radius: 10px;">
        <span  :style="{color:$utils.getScorecolor(scorea.score,three.spare2,1)}">{{ $utils.getScoreCha(scorea.score,three.spare2,1) }}</span>
        /<span  :style="{color:$utils.getScorecolor(scorea.scoreRank,three.scoreMinRank,0)}">{{ $utils.getScoreCha(scorea.scoreRank,three.scoreMinRank,0) }}</span>

      </div>
    </div>
    <div class="headc" v-else>
      <div :style="{width: rateList[0]}" style="border-bottom-left-radius: 10px;">{{year-2}}</div>
      <div :style="{width: rateList[1]}">--</div>
      <div :style="{width: rateList[2]}">--</div>
      <div :style="{width: rateList[3]}" v-if="showflag">--</div>
      <div :style="{width: rateList[4]}">--</div>
      <div :style="{width: rateList[5]}">--</div>
      <div :style="{width: rateList[6]}" style="border-bottom-right-radius: 10px;">--</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        one: null,
        two: null,
        three: null,
        obj: null,
        scorea: this.$utils.getlocalStorage("scoreInfo"),
        showflag: this.$utils.getlocalStorage('userInfo').userRole==2||this.$utils.getlocalStorage('userInfo').userRole==3,
        rateList:[]
      }
    },
    props: {
      score: Array,
      year: Number
    },
    methods: {
      getNull(str) {
        if (str != null && str != "") {
          return str;
        } else {
          return "--";
        }
      },
      getdata(){
        if (this.obj) {
          for (let i = 0; i < this.obj.length; i++) {
            if (this.obj[i].scoreYear == this.year) {
              this.one = this.obj[i]
            } else if (this.obj[i].scoreYear == this.year - 1) {
              this.two = this.obj[i]
            } else if (this.obj[i].scoreYear == this.year - 2) {
              this.three = this.obj[i]
            }
          }
        }
      }
    },
    watch: {
      score:function(a){
        this.obj = a
        this.getdata()
      }
    },
    mounted() {
    },
    created() {
      this.obj = this.score
      if(this.showflag){
        this.rateList = ['50px','40px','50px','48px','48px','64px','95px']
      } else {
        this.rateList = ['60px','55px','55px','0px','55px','75px','95px']
      }
      this.getdata()

    }

  }
</script>

<style>
  .cont {
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    /* padding: 10px; */
    border-radius: 15px;
    font-size: 12px;
    margin-right: 10px;
  }

  .headc {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

  }

  .headc div {
    width: 100%;
    text-align: center;
    padding: 5px;
    border: 1px solid #c0c4cc;
  }

  .heada div {
    background-color: #F53824;
    border-color: #F53824;
    color: #FFFFFF;
  }


  .headc div:nth-of-type(1) {
    width: 52px;
    color: #F53824;
    font-weight: 600;
  }

  .heada div:nth-of-type(1) {
    width: 52px;
    color: #FFFFFF;
    font-weight: 600;
  }

  .headc div:nth-of-type(2) {
    width: 52px;
  }

  .headc div:nth-of-type(3) {
    width: 52px;
  }

  .headc div:nth-of-type(4) {
    width: 52px;
  }

  .headc div:nth-of-type(5) {
    width: 52px;
  }
  .headc div:nth-of-type(6) {
    width: 64px;
  }
  .headc div:nth-of-type(7) {
    width: 75px;
  }
</style>



// WEBPACK FOOTER //
// src/views/yiscore.vue